import { render } from "./TheConsumerGenerals.vue?vue&type=template&id=af802eb6"
import script from "./TheConsumerGenerals.vue?vue&type=script&lang=js"
export * from "./TheConsumerGenerals.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__